module.exports = __webpack_public_path__ + "img/DSC00579-cropped-compressed.bb7aaf61.webp";